export default "__VITE_ASSET__Dt39vNhx__"